export const WHATSAPP_NUMBER = "919540087445";
export const WHATSAPP_MESSAGE =
  "Assalamu Alaikum! We would love to attend Haya Noor Jamal's Aqiqah Ceremony at Aahil Villa Banquets on 19 October 2026.";
export const VENUE_NAME = "Aahil Villa Banquets";
export const VENUE_ADDRESS =
  "G-57, Pillar No. 204, Near Kalindi Kunj Metro Station, Madanpur Khadar, New Delhi 110076";
export const VENUE_MAP_URL = "https://share.google/CDo9X9ipZUOAAcZB2";
export const CEREMONY_DATE = new Date("2026-10-19T19:00:00");
export const CEREMONY_DATE_LABEL = "19 October 2026";

export const whatsappUrl = () =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
